export default __webpack_public_path__ + "images/icon-login-webinars.png?54475a432a4a77e9a9311c729de55711";